<a (click)="handleMainMenuAction()" class="nav-link" [ngClass]="{active: isMainActive || isOneOfChildrenActive}">
    <img src="{{ menuItem.Image }}" alt="image" class="img-fluid">
    <p>{{ menuItem.name }}</p>
    <i *ngIf="isExpandable && menuItem.children.length > 0" class="right fas fa-angle-right" [@rotate]="isMenuExtended"></i>
    
</a>
<ul class="nav nav-treeview" *ngFor="let item of menuItem.children" [@openClose]="isMenuExtended">
    <li class="nav-item">
        <a [routerLink]="item.path" [routerLinkActive]="'active'" class="nav-link" >
            <i class="fa-solid fa-caret-right"></i>
            <p>{{ item.name }}</p>
        </a>
    </li>
</ul>


